<main>
<div class="container">
    <div class="topheadtitle">
        <h4 id="dow-usage-title">Day of Week Usage Report </h4>
    </div>

    <div style="display: block;">
        <canvas baseChart id="dayofweekUsageReport" title="Day of Week Usage Report " [data]="barChartData"
            [options]="barChartOptions" [legend]="barChartLegend" [type]="'bar'" [attr.role]="'img'"
            [attr.aria-labelledby]="'dow-usage-title dow-usage-desc'">
            <!-- Fallback text for very old/unsupported browsers -->
            Day of Week Usage Report bar chart.
        </canvas>

        <!-- Screen-reader-only description -->
        <p id="dow-usage-desc" class="visually-hidden">
            Bar chart summarizing usage counts by day of week. Use the data table view (if available) for exact values.
        </p>
    </div>
</div>
</main>
